import { JSX } from "react";
import { useTranslation } from "react-i18next";

import Spinner from "@/components/helpers/Spinner/Spinner";

import { OrderType } from "@/api/user/user.types";
import { useGetOrders } from "@/hooks/api/user.hooks";
import { currencyFormat } from "@/utils/currency";

const PaymentList = ({ orderType }: { orderType: OrderType }): JSX.Element => {
  const { t } = useTranslation();

  const { data: orders, isLoading } = useGetOrders({ orderType });

  const formateDate = (time: string) => {
    return new Date(time).toLocaleDateString("ru", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
    });
  };

  if (isLoading)
    return (
      <div className="hidden h-52 w-full items-center justify-center max-2xl:flex max-lg:hidden max-md:flex">
        <Spinner />
      </div>
    );

  return (
    <div className={"hidden space-y-4 max-2xl:block max-lg:hidden max-md:block max-sm:!mt-4"}>
      <hr className={"h-px w-full border-surface-bright"} />
      <ul className="divide-y divide-surface-bright max-sm:!mt-0">
        {orders?.results.map((item) => (
          <li className={"space-y-3  py-5 max-sm:py-2"} key={item.id}>
            <div className={"flex items-center justify-between"}>
              <h3 className={"text-grey-1"}>{t("Payment.date-of-payment")}</h3>
              <p>{formateDate(item.created_at)}</p>
            </div>
            <div className={"flex items-center justify-between"}>
              <h3 className={"text-grey-1"}>{t("Payment.category")}</h3>
              <p>{t(`Order.status.${item.order_type}`)}</p>
            </div>
            <div className={"flex items-center justify-between"}>
              <h3 className={"text-grey-1"}>{t("Payment.amount")}</h3>
              <p>
                {item.order_type == "subscription" ? "-" : "+"}
                {t("General.som", {
                  value: currencyFormat((item.amount == 0 ? item.balance_sum : item.amount) / 100),
                })}
              </p>
            </div>
            <div className={"flex items-center justify-between"}>
              <h3 className={"text-grey-1"}>{t("Payment.method")}</h3>
              <p>{item.payment_service.toUpperCase()}</p>
            </div>
          </li>
        ))}
      </ul>
      <hr className={"h-px w-full border-surface-container"} />
    </div>
  );
};

export default PaymentList;
